'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness2 = function ImageBrightness2(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z' })
  );
};
ImageBrightness2 = (0, _pure2.default)(ImageBrightness2);
ImageBrightness2.displayName = 'ImageBrightness2';
ImageBrightness2.muiName = 'SvgIcon';

exports.default = ImageBrightness2;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/brightness-2.js
// module id = 1495
// module chunks = 0